import { SeachFieldEnum } from "../components/enums/documentEnum";
import { normalizeHomoglyphs } from "../filters/seachFilter";

export const addColumnProperty = (columns, property, value) => {
  return columns.map(column => ({
    ...column,
    [property]: value,
  }));
};

// export const baseSeach = (option, filterValue) => {
//   if (!filterValue) return true;

//   const words = filterValue
//     .toLowerCase()
//     .split(/\s+/)
//     .filter(Boolean);

//   const searchableText = `${option.label || ''} ${option.id || ''}`.toLowerCase();

//   // все слова должны присутствовать
//   return words.every(word => searchableText.includes(word));
// };

// Вариант поиска с сортировкой по релевантности

// const scoreItem = (item, searchTerms, nomenclature) => {
//   const name = (nomenclature?.nameNomenclature ?? "").toLowerCase();
//   const unit = (nomenclature?.unit ?? "").toLowerCase();

//   const characteristic = nomenclature?.characteristics?.find(
//     x => item.characteristicId === x.id
//   );

//   const characteristicName = (characteristic?.name ?? "").toLowerCase();
//   const serial = (item?.serial ?? item?.serialNumber ?? "").toLowerCase();

//   const fields = [name, characteristicName, unit, serial];

//   let score = 0;

//   for (const term of searchTerms) {
//     for (const field of fields) {
//       if (!field) continue;

//       if (field === term) score += 100;           // точное совпадение
//       else if (field.startsWith(term)) score += 50; // начало слова
//       else if (field.includes(term)) score += 10;    // частичное
//     }
//   }

//   return score;
// };

// export const filterItems = (items, searchText, nomenclatures, fieldName = SeachFieldEnum.ID) => {
//   if (!searchText?.trim()) return items;

//   const searchTerms = searchText?.toLowerCase()?.split(/\s+/).filter(Boolean);; // Разделяем текст по пробелам
//   return items
//     .map(item => {
//       const nomenclature = nomenclatures.find(x => x.id === item[fieldName]);

//       return {
//         item,
//         score: scoreItem(item, searchTerms, nomenclature),
//       };
//     })
//     .filter(x => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map(x => x.item);
// };
export const compareDocNumbers = (a, b) => {
  const parse = (val) => {
    if (val == null) return { type: "empty" };

    const str = String(val).trim();

    // Составной номер: A-10
    if (str.includes("-")) {
      const [prefix, num] = str.split("-");
      const parsedNum = Number(num);

      return {
        type: "composite",
        prefix: prefix || "",
        number: isNaN(parsedNum) ? null : parsedNum,
        raw: str,
      };
    }

    // Чисто число
    const asNumber = Number(str);
    if (!isNaN(asNumber)) {
      return { type: "number", number: asNumber, raw: str };
    }

    // Строка
    return { type: "string", value: str };
  };

  const pa = parse(a);
  const pb = parse(b);

  // === COMPOSITE vs COMPOSITE ===
  if (pa.type === "composite" && pb.type === "composite") {
    // сначала по числу
    if (pa.number !== pb.number) {
      return (pa.number || 0) - (pb.number || 0);
    }
    // потом по префиксу
    return pa.prefix.localeCompare(pb.prefix, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  }

  // === NUMBER vs NUMBER ===
  if (pa.type === "number" && pb.type === "number") {
    return pa.number - pb.number;
  }

  // === NUMBER vs COMPOSITE ===
  if (pa.type === "number" && pb.type === "composite") {
    if (pb.number != null && pa.number !== pb.number) {
      return pa.number - pb.number;
    }
    return String(a).localeCompare(String(b), undefined, {
      numeric: true,
      sensitivity: "base",
    });
  }

  if (pa.type === "composite" && pb.type === "number") {
    if (pa.number != null && pa.number !== pb.number) {
      return pa.number - pb.number;
    }
    return String(a).localeCompare(String(b), undefined, {
      numeric: true,
      sensitivity: "base",
    });
  }

  // === STRING vs STRING ===
  if (pa.type === "string" && pb.type === "string") {
    return pa.value.localeCompare(pb.value, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  }

  // === MIXED (string / number / composite) ===
  // универсальный fallback
  return String(a).localeCompare(String(b), undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

export const filterItems = (items, searchText, nomenclatures, fieldName = SeachFieldEnum.ID) => {
  if (!searchText?.trim()) return items;

  // Нормализуем поисковый запрос один раз
  const normalizedSearch = normalizeHomoglyphs(searchText.toLowerCase());
  const searchTerms = normalizedSearch.split(/\s+/).filter(Boolean); // убираем пустые строки

  return items.filter((item) => {
    // Если id нет или номенклатура не найдена — оставляем строку
    if (!item[fieldName]) return true;

    const nomenclature = nomenclatures.find(x => x.id === item[fieldName]);
    const characteristic = nomenclature?.characteristics?.find(x => item.characteristicId === x.id);

    // Собираем все поля для поиска и нормализуем их
    const searchableText = normalizeHomoglyphs(`
      ${nomenclature?.nameNomenclature || ''}
      ${characteristic?.name || ''}
      ${nomenclature?.unit || ''}
      ${item?.serial || ''}
      ${item?.serialNumber || ''}
      ${nomenclature?.article || ''}
      ${nomenclature?.category || ''}
    `.toLowerCase());

    // Все слова из поиска должны найтись в нормализованном тексте
    return searchTerms.every((term) => searchableText.includes(term));
  });
};

export const customFilterInColumn = (searchObject) => {
  const item = searchObject.item;
  const searchString = searchObject.text;
  
  if (!searchString || !item.label) return true;

  const normalizedSearch = normalizeHomoglyphs(searchString.toLowerCase());
  const searchWords = normalizedSearch
    .split(/\s+/)
    .filter(word => word.length > 0);

  const itemLabel = normalizeHomoglyphs(item.label.toLowerCase());

  return searchWords.every(word =>
    itemLabel.includes(word)
  );
};

export const customFilterInSimpleColumn = (params) => {
  console.log("FILTER PARAMS:", params);

  const { value, filterValue } = params || {};

  console.log("CELL VALUE:", value);
  console.log("FILTER VALUE:", filterValue);

  if (!filterValue) return true;

  const normalize = (v) =>
    normalizeHomoglyphs(String(v || "").toLowerCase());

  const searchWords = normalize(filterValue)
    .split(/\s+/)
    .filter(Boolean);

  const text = normalize(value);

  const result = searchWords.every(word => text.includes(word));

  console.log("SEARCH WORDS:", searchWords);
  console.log("NORMALIZED TEXT:", text);
  console.log("MATCH RESULT:", result);
};

/**
 * Фильтрует массив элементов по поисковому запросу с учетом указанных полей
 * @param {Array} items - Массив элементов для фильтрации
 * @param {string} searchText - Текст для поиска
 * @param {Array} searchFields - Массив строк с названиями полей для поиска
 * @param {Function} [getFieldValue] - Функция для получения значения поля (опционально)
 * @returns {Array} Отфильтрованный массив элементов
 */
export const baseFilterItems = (items, searchText, searchFields, getFieldValue) => {
  if (!searchText?.trim()) return items;

  const searchTerms = searchText.toLowerCase().split(/\s+/).filter(Boolean);

  return items.filter(item => {
    // Получаем значения всех полей для текущего элемента
    const fieldValues = searchFields.map(field => {
      const value = getFieldValue
        ? getFieldValue(item, field)
        : item[field];

      return String(value || '').toLowerCase();
    });

    // Проверяем, что все термины есть хотя бы в одном из полей
    return searchTerms.every(term =>
      fieldValues.some(value => value.includes(term))
    );
  });
};

export const filterCBItems = (items, searchText, nomenclatures) => {
  if (!searchText?.trim()) return items;

  const searchTerms = searchText?.toLowerCase()?.split(/\s+/); // Разделяем текст по пробелам
  return items.filter((item) => {
    const nomenclature = nomenclatures.find((n) => n.nomenclatureId === item.id && item.characteristicId === n.characteristicId);
    const name = nomenclature?.nameNomenclature?.toLowerCase() || "";
    const characteristic = nomenclature?.nameCharacteristic?.toLowerCase() || "";

    // Проверяем, что хотя бы одно слово содержится в данных
    return searchTerms.every((term) =>
      [name, characteristic].some((field) => field.includes(term))
    );
  });
};

// В методе убрана номенклатура, чтобы искал среди значений подобраных
export const filterCBItemsFixed = (options, searchText) => {
  if (!searchText?.trim()) return options;

  const searchTerms = searchText.toLowerCase().split(/\s+/);

  return options.filter((option) => {
    const title = option.title?.toLowerCase() || "";

    // Проверяем, что хотя бы одно слово содержится в названии опции
    return searchTerms.every((term) =>
      title.includes(term)
    );
  });
};


export const filterItemsStores = (items, searchText, stores, fieldName = SeachFieldEnum.NOMENCLATURE) => {
  if (!searchText.trim()) return items;

  // Нормализуем поисковый запрос один раз
  const normalizedSearch = normalizeHomoglyphs(searchText.toLowerCase());
  const searchTerms = normalizedSearch.split(/\s+/).filter(Boolean);

  return items.filter((item) => {
    let name;
    let store;
    let characteristic = "";

    if (item.productId !== null && item.productId !== undefined) {
      store = stores.find((store) => store.id === item.productId);
    } else {
      if (item.characteristicId) {
        store = stores.find((store) => 
          store.nomenclatureId === item[fieldName] && 
          store.characteristicId === item.characteristicId
        );
        characteristic = store?.characteristic?.toLowerCase() || "";
      } else {
        store = stores.find((store) => store.nomenclatureId === item[fieldName]);
      }
    }

    // Формируем имя для поиска
    name = (store?.hasSerial
      ? `[${store?.serialNumber}] ${store?.nomenclature}`
      : store?.nomenclature)?.toLowerCase() || "";

    // Нормализуем объединённый текст для поиска
    const searchableText = normalizeHomoglyphs(`${name} ${characteristic}`);

    // Все слова из поиска должны найтись
    return searchTerms.every((term) => searchableText.includes(term));
  });
};


export const filterItemsComplectation = (items, searchText = "", /* stores, nomenclatures — не нужны */) => {
  if (!searchText.trim()) return items;

  const searchTerms = searchText.toLowerCase().split(/\s+/); // Разделяем текст по пробелам

  return items.filter((item) => {
    const nomencl = item.nomenclatureName?.toLowerCase() || "";
    const characteristic = item.characteristic?.toString().toLowerCase() || "";
    const serial = item.serialNumber?.toLowerCase() || "";
    const category = item.category?.toLowerCase() || "";

    // Проверяем, что хотя бы один термин содержится в данных
    return searchTerms.every((term) =>
      [nomencl, characteristic, serial, category].some((field) => field.includes(term))
    );
  });
};

export const filterItemsApplications = (items, searchText, specifications) => {
  if (!searchText.trim()) return items;

  const searchTerms = searchText.toLowerCase().split(/\s+/); // Разделяем текст по пробелам
  return items.filter((item) => {
    const specif = specifications.find((n) => n.id === item.specificationId || n.id === item.id);
    const name = specif?.name?.toLowerCase() || "";
    const serial = specif?.serial?.toString().toLowerCase() || "";
    const status = item?.status?.toLowerCase() || "";

    // Проверяем, что хотя бы один термин содержится в данных
    return searchTerms.every((term) =>
      [name, serial, status].some((field) => field.includes(term))
    );
  });
};

export const duplicateRow = (rowData, items, setItem) => {
  const rowIndex = items.findIndex(item => item.id === rowData.id);

  const duplicatedRow = {
    ...rowData,
    id: items.length + 1, // временный id
  };

  // новую строку после текущей
  const newItems = [
    ...items.slice(0, rowIndex + 1),
    duplicatedRow,
    ...items.slice(rowIndex + 1)
  ];

  // Пересчитываем id всех строк, чтобы не было конфликтов
  setItem(newItems.map((item, index) => ({
    ...item,
    id: index + 1
  })));
};

export const copyRow = (rowData, items) => {
  const rowIndex = items.findIndex(item => item.id === rowData.id);

  const duplicatedRow = {
    ...rowData,
    id: items.length + 1, // временный id
  };

  // Вставляем новую строку после текущей
  return [
    ...items.slice(0, rowIndex + 1),
    duplicatedRow,
    ...items.slice(rowIndex + 1)
  ].map((item, index) => ({
    ...item,
    id: index + 1,
    hasError: false
  }));
};

// Функция для расчета итоговой суммы
export const calculateTotalSum = (paidStatuses) => {
  if (!paidStatuses || paidStatuses.length === 0) {
    return 0;
  }
  let totalSum = 0;
  let paymentStack = [];

  paidStatuses.forEach(stat => {
    if (stat.paymentStatus !== "Оплачен с отсрочкой") {
      switch (stat.paymentStatus) {
        case "Оплачен":
        case "Частично оплачен":
          paymentStack.push(stat);
          totalSum += stat.paymentSum;
          break;
        case "Не оплачен":
          if (paymentStack.length > 0) {
            let lastPayment = paymentStack.pop();
            totalSum -= lastPayment.paymentSum;
          }
          break;
        default:
          throw new Error(`Неизвестный статус: ${stat.paymentStatus}`);
      }
    }
  });

  return totalSum;
};